"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVENTS_WEB_API_BASE = '/_api/wix-one-events-server';
exports.MEMBERS_PERMISSIONS_BASE = '/_api/member-permissions-server';
//# sourceMappingURL=endpoints.js.map